/** Catalogue stays complete within Smart Home; Roof Claim alone is not that scope. */
export const smartHomeVideosVisible = (
  products: readonly string[],
  roofClaimShown: boolean,
): boolean =>
  products.includes('Security') || (products.length === 0 && !roofClaimShown)
